import React, { Component } from 'react';

import features from 'lib/common/features';

class SingleSeatWarning extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (features.isEnabled('singleSeatWarning') === false) {
      return null;
    }
    return (
      <div className="single-seat__warning">
        <p>{features.getOption('singleSeatWarning', 'warning')}</p>
      </div>
    );
  }
}

export default SingleSeatWarning;



// WEBPACK FOOTER //
// ./src/javascripts/components/SingleSeatWarning.js